import { memoizeWith } from 'ramda';

const MEASUREMENT_NO_WRAP_ELEMENT_ID = '__react_svg_text_measurement_no_wrapped_id';
const SVG_URL = 'http://www.w3.org/2000/svg';
const SVG = 'svg';
const TEXT = 'text';
const ID = 'id';
const SVG_STYLE = {
  width: '0',
  height: '0',
  position: 'fixed',
  top: '-100%',
  left: '-100%',
};

const measureNoWrappedTextBase = (str = '', style = {}) => {
  try {
    let textEl = document.getElementById(MEASUREMENT_NO_WRAP_ELEMENT_ID);

    if (!textEl) {
      const svg = document.createElementNS(SVG_URL, SVG);
      Object.assign(svg.style, SVG_STYLE);

      textEl = document.createElementNS(SVG_URL, TEXT);
      textEl.setAttribute(ID, MEASUREMENT_NO_WRAP_ELEMENT_ID);

      svg.appendChild(textEl);
      document.body.appendChild(svg);
    }

    Object.assign(textEl.style, style);
    textEl.textContent = str;

    return textEl.getBBox();
  } catch (e) {
    return {};
  }
};

export const measureNoWrappedText = memoizeWith(
  (str, style) => `${str}_${JSON.stringify(style)}`,
  measureNoWrappedTextBase
);
